var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c(
            "vs-tabs",
            { attrs: { color: _vm.colorx } },
            [
              _c(
                "vs-tab",
                { attrs: { label: _vm.$t("product.title") } },
                [
                  _c("validation-observer", {
                    ref: "validator",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var valid = ref.valid
                          return [
                            _c(
                              "div",
                              { staticClass: "flex flex-col gap-4 mt-1" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col gap-2" },
                                  [
                                    _c("div", { staticClass: "w-full" }, [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c(
                                          "div",
                                          { staticClass: "mb-1" },
                                          [
                                            _c("validation-provider", {
                                              staticClass: "flex-grow",
                                              attrs: {
                                                name: _vm.$t("product.status"),
                                                rules: "required",
                                                slim: "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                _vm.$t(
                                                                  "product.status"
                                                                ),
                                                              "label-for":
                                                                "status",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-radio-group",
                                                              {
                                                                staticClass:
                                                                  "required mr-2",
                                                                attrs: {
                                                                  id: "status",
                                                                  name: "status",
                                                                  options:
                                                                    _vm.statusList,
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.model
                                                                      .status,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.model,
                                                                        "status",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "model.status",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-muted d-block mt-1",
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    "Liberado"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " é o único status visível na busca do aluno e que pode ser comprado. "
                                                                ),
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    "Criando"
                                                                  ),
                                                                ]),
                                                                _vm._v(" e "),
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    "Editando"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " mantêm o produto invisível enquanto você monta o cadastro; "
                                                                ),
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    "Inativo"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " tira da venda um produto que já esteve liberado. "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "w-full" },
                                      [
                                        _c("validation-provider", {
                                          staticClass: "flex-grow",
                                          attrs: {
                                            name: _vm.$t("responsible_entity"),
                                            rules: "required",
                                            slim: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("select-suggestion", {
                                                      attrs: {
                                                        id: "legal_entity_id",
                                                        column:
                                                          "company_name,trading_name,cnpj",
                                                        model: "LegalEntity",
                                                        label:
                                                          _vm.$t(
                                                            "responsible_entity"
                                                          ),
                                                        appendClearOption: false,
                                                        placeholderText:
                                                          _vm.pessoaJuridicaLocked
                                                            ? ""
                                                            : "Digite o nome do estabelecimento",
                                                        itemTextFormat:
                                                          _vm.legalEntityItemTextFormat,
                                                        isDisabled:
                                                          _vm.pessoaJuridicaLocked,
                                                        required: true,
                                                      },
                                                      model: {
                                                        value: _vm.legalEntity,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.legalEntity = $$v
                                                        },
                                                        expression:
                                                          "legalEntity",
                                                      },
                                                    }),
                                                    _vm.planIdFromQuery
                                                      ? _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-muted d-block",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "product.entity_locked_by_plan"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "w-full grid grid-cols-3 gap-2",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex col-span-2" },
                                          [
                                            _c("validation-provider", {
                                              staticClass: "flex-grow",
                                              attrs: {
                                                name: _vm.$t("product.name"),
                                                rules: "required",
                                                slim: "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                _vm.$t(
                                                                  "product.name"
                                                                ),
                                                              "label-for":
                                                                "product_name",
                                                            },
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              staticClass:
                                                                "required",
                                                              attrs: {
                                                                id: "product_name",
                                                                state:
                                                                  errors.length >
                                                                  0
                                                                    ? false
                                                                    : null,
                                                                name: "product_name",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.model
                                                                    .name,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.model,
                                                                      "name",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "model.name",
                                                              },
                                                            }),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex" },
                                          [
                                            _c("validation-provider", {
                                              staticClass: "flex-grow",
                                              attrs: {
                                                name: _vm.$t("product.price"),
                                                rules: "required",
                                                slim: "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                _vm.subscriptionPlan
                                                                  ? _vm.$t(
                                                                      "product.subscription_price"
                                                                    )
                                                                  : _vm.$t(
                                                                      "product.price"
                                                                    ),
                                                              "label-for":
                                                                "product_price",
                                                            },
                                                          },
                                                          [
                                                            _vm.subscriptionPlan
                                                              ? _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-muted d-block mb-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "product.subscription_price_help",
                                                                            {
                                                                              interval:
                                                                                (
                                                                                  _vm
                                                                                    .subscriptionPlan
                                                                                    .interval_label ||
                                                                                  ""
                                                                                ).toLowerCase(),
                                                                            }
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "money",
                                                              _vm._b(
                                                                {
                                                                  class: [
                                                                    "form-control",
                                                                    "required",
                                                                    {
                                                                      "is-invalid":
                                                                        errors.length >
                                                                        0,
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    id: "product_price",
                                                                    name: "product_price",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.model
                                                                        .price,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.model,
                                                                          "price",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "model.price",
                                                                  },
                                                                },
                                                                "money",
                                                                _vm.moneyMask,
                                                                false
                                                              )
                                                            ),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm.subscriptionPlan
                                      ? _c(
                                          "div",
                                          { staticClass: "w-full mt-2" },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "subscription_plan.register_on_payment_gateway"
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-muted d-block mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "subscription_plan.register_on_payment_gateway_help"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant:
                                                        _vm.gatewayStatus
                                                          .variant,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.gatewayStatus.label
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm.gatewayStatus.hint
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "d-block mt-1",
                                                        class:
                                                          _vm.gatewayStatus
                                                            .hintClass,
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.gatewayStatus
                                                                .hint
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-muted d-block",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "product.subscription_plan_linked",
                                                        {
                                                          name: _vm
                                                            .subscriptionPlan
                                                            .name,
                                                        }
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      { staticClass: "w-full" },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "text-sm pl-1" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("product.description")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("ComplexEditor", {
                                          attrs: {
                                            editor_data: _vm.model.description,
                                          },
                                          on: {
                                            "update:editor_data": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.model,
                                                "description",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "w-full" },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "text-sm pl-1" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("product.how_works")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("ComplexEditor", {
                                          attrs: {
                                            editor_data: _vm.model.how_works,
                                          },
                                          on: {
                                            "update:editor_data": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.model,
                                                "how_works",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "w-full" },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "text-sm pl-1" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("product.guidelines")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("ComplexEditor", {
                                          attrs: {
                                            editor_data: _vm.model.guidelines,
                                          },
                                          on: {
                                            "update:editor_data": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.model,
                                                "guidelines",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "w-full flex gap-2 justify-end",
                                  },
                                  [
                                    !_vm.isEdit()
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName: "v-permission",
                                                value: "products.create",
                                                expression: "'products.create'",
                                              },
                                            ],
                                            attrs: {
                                              variant: "primary",
                                              disabled: !_vm.validateForm,
                                            },
                                            on: { click: _vm.createOrUpdate },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("action.save")) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.isEdit()
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName: "v-permission",
                                                value: "products.edit",
                                                expression: "'products.edit'",
                                              },
                                            ],
                                            attrs: {
                                              variant: "primary",
                                              disabled: !_vm.validateForm,
                                            },
                                            on: { click: _vm.createOrUpdate },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("action.save")) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-secondary" },
                                        on: { click: _vm.goBack },
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-50",
                                          attrs: { icon: "CornerUpLeftIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle" },
                                          [_vm._v(_vm._s(_vm.$t("back")))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.isEdit()
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-wrap items-center",
                                      },
                                      [
                                        _c(
                                          "vue-dropzone",
                                          {
                                            ref: "fileUploadZone",
                                            staticStyle: {
                                              width: "100%",
                                              "margin-bottom": "10px",
                                            },
                                            attrs: {
                                              id: "upload",
                                              "use-font-awesome": true,
                                              options: _vm.dropzoneOptions,
                                              "use-custom-dropzone-options": true,
                                              useCustomSlot: true,
                                            },
                                            on: {
                                              "vdropzone-success":
                                                _vm.successSendFile,
                                              "vdropzone-sending": _vm.sending,
                                              "vdropzone-error": _vm.error,
                                              "vdropzone-file-added": _vm.added,
                                              "vdropzone-queue-complete":
                                                _vm.complete,
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "dropzone-custom-content",
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticClass:
                                                      "dropzone-custom-title",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "messages.drag_and_drop_file"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "subtitle" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "messages.or_select_file_in_computer"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "subtitle" },
                                                  [
                                                    _vm._v(
                                                      " Tamanho recomendado para imagens: 1200×675px (paisagem, 16:9) — é a foto usada nos cards e na página de detalhes da aula, plano ou local relacionado a este produto, quando cadastrada. "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.isEdit()
                                  ? _c(
                                      "div",
                                      { staticClass: "mt-2 w-full " },
                                      [
                                        _c("media-list", {
                                          attrs: {
                                            medias: _vm.files,
                                            "show-delete": true,
                                            "action-on-click": false,
                                          },
                                          on: { deleteMedia: _vm.deleteFile },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm.isEdit()
                ? _c(
                    "vs-tab",
                    { attrs: { label: _vm.$t("product.composition_prod") } },
                    [
                      _c("div", { staticClass: "vx-row mb-2 mt-1" }, [
                        _c(
                          "div",
                          { staticClass: "vx-col w-full" },
                          [
                            _c("FormProductItem", {
                              attrs: { id: _vm.id, status: _vm.model.status },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.isEdit()
                ? _c(
                    "vs-tab",
                    {
                      attrs: {
                        label: _vm.$t("cancellation.product_policy_tab"),
                      },
                    },
                    [
                      _c("div", { staticClass: "vx-row mb-2 mt-1" }, [
                        _c(
                          "div",
                          { staticClass: "vx-col w-full" },
                          [
                            _c("ProductPolicySection", {
                              attrs: { "product-id": _vm.id },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }